import * as _ from 'lodash-es';
import util from 'util';
import { betInspect, betLogFormatters, notFormatted } from './betInspectF.mts';
// Hook for serverF to inject silencing logic (set by mcpSilentCtx in serverF)
export let isSilenced = () => false;
export const setIsSilenced = (fn) => { isSilenced = fn; };
export let getQuiet = () => false;
export const setGetQuiet = (fn) => { getQuiet = fn; };
export const registerBetLogFormatter = (fn) => {
    betLogFormatters.push(fn);
};
export { notFormatted as betLogNotFormatted };
export const betLog = (...argA) => {
    if (isSilenced() || getQuiet())
        return;
    argA = _.map(argA, betInspect);
    const noWindow = ((typeof window) == 'undefined');
    console.log(..._.map(argA, (arg) => {
        if (_.isString(arg))
            return arg;
        if (!noWindow)
            return arg;
        return util.inspect(arg, {
            showHidden: false, depth: null,
            maxArrayLength: null,
            breakLength: 300,
            colors: !!process.stdout.isTTY // disable colors when piping into subl or code -
        });
    }));
};
export const betVerboseLog = (...props) => {
    if (!process.env.VERYVERBOSE)
        return;
    betLog(...props);
};
